import { Asset } from "../state/types";

export const getMissingCameraPositions = (asset: Asset) =>
  Array.isArray(asset.missingCameraPositions)
    ? asset.missingCameraPositions.filter((position): position is string => Boolean(position))
    : [];

export const getMissingCameraTooltip = (asset: Asset) => {
  const missingCameraPositions = getMissingCameraPositions(asset);

  if (!missingCameraPositions.length) return "";

  return `Missing camera positions: ${missingCameraPositions.join(", ")}`;
};
